import React, { Fragment } from 'react';
import { useLanguage } from './LanguageContext';
export const TrustBar = () => {
  const {
    t
  } = useLanguage();
  const items = [t('trust.local'), t('trust.area'), t('trust.hours'), t('trust.payment'), t('trust.services')];
  return <div className="bg-brand-navy py-6 md:py-5 px-5" data-id="element-239">
      <div className="max-w-7xl mx-auto md:px-6 lg:px-8" data-id="element-240">
        <div className="flex flex-col md:flex-row md:flex-wrap md:justify-between items-center gap-3 md:gap-y-4 md:gap-x-2" data-id="element-241">
          {items.map((item, index) => <Fragment key={index} data-id="element-242">
              <div className="flex items-center gap-2 px-2 w-full md:w-auto justify-center md:justify-start" data-id="element-243">
                <span className="text-brand-gold text-lg leading-none" data-id="element-244">✦</span>
                <span className="text-white font-inter font-medium text-[13px] whitespace-nowrap" data-id="element-245">
                  {item}
                </span>
              </div>
              {index < items.length - 1 && <div className="hidden md:block h-6 w-[1px] bg-brand-gold/30" data-id="element-246" />}
            </Fragment>)}
        </div>
      </div>
    </div>;
};